<template>
    <div class="splash-container__block">
        <div class="splash-logo">
            <publisher-icon class="splash-logo__img" :icon-name="'IconAuthorization'" />
        </div>

        <div class="splash-load">
            <loader />
        </div>
    </div>
</template>
